import { ArrowLeft, X } from 'lucide-react'
import { useEffect, useRef, type ReactNode } from 'react'
import { useApp } from '../context'

/** Header + scroll area shared by all panel views. Moves focus to the heading on view change. */
export function PanelShell({ title, subtitle, badge, actions, children, onClose }: { title: string; subtitle?: ReactNode; badge?: ReactNode; actions?: ReactNode; children: ReactNode; onClose?: () => void }) {
  const { back, canGoBack } = useApp()
  const heading = useRef<HTMLHeadingElement>(null)
  useEffect(() => {
    heading.current?.focus({ preventScroll: true })
  }, [title])
  return (
    <div className="flex h-full min-h-0 flex-col">
      <header className="flex items-start gap-2 border-b border-border px-3 py-3">
        {canGoBack && (
          <button onClick={back} className="mt-0.5 rounded-lg p-1.5 text-muted hover:bg-surface-2 hover:text-fg" aria-label="Back">
            <ArrowLeft className="h-5 w-5" aria-hidden />
          </button>
        )}
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h2 ref={heading} tabIndex={-1} className="min-w-0 break-words text-base font-semibold outline-none">
              {title}
            </h2>
            {badge}
          </div>
          {subtitle && <div className="mt-0.5 text-sm text-muted">{subtitle}</div>}
        </div>
        {onClose && (
          <button onClick={onClose} className="rounded-lg p-1.5 text-muted hover:bg-surface-2 hover:text-fg" aria-label="Close panel">
            <X className="h-5 w-5" aria-hidden />
          </button>
        )}
      </header>
      {actions && <div className="flex flex-wrap gap-2 border-b border-border px-3 py-2">{actions}</div>}
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">{children}</div>
    </div>
  )
}
